"use strict";
import { useContext, useMemo } from "react";
import { AuthContext } from "./AuthContext";
export function useAuthRefreshToken() {
  const { authRefreshToken, setAuthRefreshToken } = useContext(AuthContext);
  return useMemo(() => {
    return [authRefreshToken, setAuthRefreshToken];
  }, [authRefreshToken, setAuthRefreshToken]);
}
